/**
 * datePanel.jsx
 *
 * @Author: apple
 * @Date: 2017/10/25 19:28
 */

import React, { Fragment, Component } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import Button from '../../button';

const weeks = [0, 1, 2, 3, 4, 5];
const days = ['日', '一', '二', '三', '四', '五', '六'];

/**
 * @ignore
 * */
class DatePanel extends Component {
  static propTypes = {};

  static defaultProps = {};

  handleSelect = value => e => {
    e.stopPropagation();
    const { onValueChange, onPanelDateChange } = this.props;
    onValueChange(value);
    onPanelDateChange(value);
  };

  render() {
    const { panelDate, value, prefixCls, disabledDate, onPanelTypeChange } = this.props;

    const startOfMonth = moment(panelDate).date(1);
    const dateOfEnd = moment(panelDate)
      .endOf('month')
      .date();
    const dayOfStart = startOfMonth.day();
    const isRange = Array.isArray(value);
    return (
      <Fragment>
        <thead className={`${prefixCls}-date-header`}>
          <tr>
            {days.map(day => (
              <th key={day}>{day}</th>
            ))}
          </tr>
        </thead>
        <tbody className={`${prefixCls}-body`}>
          {weeks.map((week, index) => (
            <tr key={index}>
              {days.map((day, dayIndex) => {
                const dateIndex = week * 7 + dayIndex - dayOfStart;
                const item = moment(startOfMonth).add(dateIndex, 'day');
                const isToday = value && item.isSame(moment(), 'day');
                const isRangeStart = isRange && value[0] && item.isSame(value[0], 'day');
                const isRangeEnd = isRange && value[1] && item.isSame(value[1], 'day');
                const isSelectedSingleDay = !isRange && value && item.isSame(value, 'day');
                const inDifferentMonth = dateIndex < 0 || dateIndex > dateOfEnd - 1;
                const disabled = disabledDate && disabledDate(item);
                const classes = classNames(`${prefixCls}-date-item`, {
                  [`${prefixCls}-date-item-selected`]:
                    !inDifferentMonth && (isRangeStart || isRangeEnd || isSelectedSingleDay),
                  [`${prefixCls}-date-item-start`]: !inDifferentMonth && isRangeStart,
                  [`${prefixCls}-date-item-end`]: !inDifferentMonth && isRangeEnd,
                  [`${prefixCls}-date-item-disabled`]: disabled,
                  [`${prefixCls}-date-item-different-month`]: inDifferentMonth,
                  [`${prefixCls}-date-item-today`]: isToday,
                });
                const cellClasses = classNames(`${prefixCls}-date-cell`, {
                  [`${prefixCls}-date-cell-in-range`]:
                    !inDifferentMonth &&
                    isRange &&
                    value.length === 2 &&
                    item.isBetween(value[0], value[1]),
                });
                return (
                  <td key={dayIndex} title={item.format('YYYY-MM-DD')} className={cellClasses}>
                    <Button
                      className={classes}
                      disabled={disabled}
                      onClick={this.handleSelect(item)}
                      type={inDifferentMonth ? 'secondary' : null}>
                      {item.date()}
                    </Button>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </Fragment>
    );
  }
}

export default DatePanel;



// WEBPACK FOOTER //
// ./src/datePicker/panel/DatePanel.jsx